import React from "react";
import { useRouter } from "next/router";
import { IResponsePlans } from "@/services/endpoints/plans";
import { Container, ContainerBody, ContainerTitle } from "./styles";
import { Api } from "@/services/configs/axios";
import { parseToSnakeCase } from "@/utils/parseToSnakCase";
import { dictMedias } from "@/utils/SvgDictionaries/svg";
import { Square } from "@/components/Plano/partials/Sobre/body_information/styles";

interface Iprops {
  plano: IResponsePlans;
}

const CardComponent: React.FC<Iprops> = ({ plano }) => {
  const router = useRouter();

  const handleNavigate = React.useCallback((id: number) => {
    router.push(`/plano/${id}`);
  }, [router]);

  const fetchIcon = async (iconPath: any) => {
    if (!iconPath) return null;
    try {
      const response = await Api.get(`final/download/${iconPath}`);
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const rehydratePlans = React.useCallback(async () => {
    const iconUrl = await fetchIcon(plano?.arquivosPlano?.caminhoIcone);
    if (!iconUrl) return;
    setMedias(iconUrl);
  }, [plano?.arquivosPlano?.caminhoIcone]);

  const [medias, setMedias] = React.useState<any>("");
  React.useEffect(() => {
    if (dictMedias[parseToSnakeCase(plano?.titulo)]?.icon != undefined) {
      setMedias(dictMedias[parseToSnakeCase(plano?.titulo)]?.icon);
    } else {
      rehydratePlans()
    }
  }, [plano?.titulo, rehydratePlans]);

  return (
    <Container onClick={() => handleNavigate(plano?.id)}>
      <ContainerTitle status={plano?.status}>
        <h1 className="resizeable-accessibility">{plano?.titulo}</h1>
      </ContainerTitle>
      <ContainerBody>
        {medias ? (
          <>
            {typeof medias === 'string' ? (
                <div style={{ width: '30%', justifyContent: 'center' , display: 'flex'}} dangerouslySetInnerHTML={{ __html: medias }} />
            ) : (
              medias
            )}
          </>
        ) : (
          plano?.svg
        )}

        <p style={{ height: '190px', maxHeight: '200px', overflow: 'hidden' }} className="resizeable-accessibility">{plano?.descricao}</p>
      </ContainerBody>
    </Container>
  );
};

export const Card = React.memo(CardComponent);
Card.displayName = 'Card';
